/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ProcessOfferStatusDto = {
    Draft: 'DRAFT',
    Offering: 'OFFERING',
    OfferAccepted: 'OFFER_ACCEPTED',
    ConfirmedForRealization: 'CONFIRMED_FOR_REALIZATION',
    Finished: 'FINISHED',
    Executed: 'EXECUTED',
    Payed: 'PAYED',
    InRealization: 'IN_REALIZATION',
    Canceled: 'CANCELED',
} as const;

export type ProcessOfferStatusDto = typeof ProcessOfferStatusDto[keyof typeof ProcessOfferStatusDto];



